import { Controller } from '@hotwired/stimulus'
import AudioPlayer from 'utils/audio_player'
import Modal from 'components/modal'

export default class WistiaLazyVideoController extends Controller {
  initialize() {
    this.playerClass = this.element.dataset.playerClass
    this.element.addEventListener("click", (_) => {
      // We need to unlock the AudioContext so we can play any sound from videos.
      // This is mainly used in CLE attendance verification, but it may be used in other videos as well in the future.
      const player = new AudioPlayer()
      player.unlock()

      if (this.element.dataset.modalPrompt) {
        Modal.show(this.element.dataset.modalPrompt, {}, {
          onClose: (modal) => {
            Modal.removeClassFromBody()
            Modal.emitCloseEvent(modal)
            this.loadVideo()
          }
        })
      } else {
        this.loadVideo()
      }
    })

    document.addEventListener("PlayWistiaVideo", (evt) => {
      if (evt.detail.wistiaVideoId === this.element.dataset.wistiaVideoId) {
        this.loadVideo()
      }
    })
  }

  loadVideo() {
    const wistiaEmbed = document.createElement("div")
    wistiaEmbed.setAttribute("class", `c-wistia-video-lazy ${this.playerClass} wistia_embed autoPlay=true`)
    wistiaEmbed.setAttribute("style", "height:100%;width:100%")
    wistiaEmbed.innerHTML = this.element.innerHTML

    if (this.element.parentElement) {
      this.element.outerHTML = wistiaEmbed.outerHTML
    }
  }
}
